import React from 'react';
import { BsInstagram, BsLinkedin, BsGithub } from 'react-icons/bs';

const SocialMedia = () => (
  <div className="app__social">
    <div>
      <BsLinkedin
        onClick={() =>
          window.open('https://www.linkedin.com/in/silviocustodio/')
        }
      />
    </div>
    <div>
      <BsGithub
        onClick={() => window.open('https://github.com/silviocustodio')}
      />
    </div>
    {/* <div>
      <BsInstagram />
    </div> */}
  </div>
);

export default SocialMedia;
